export default (function (_ref) {
  var service = _ref.service,
    request = _ref.request;
  return {
    getLifestyleTagList: function getLifestyleTagList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/subject_tag/get",
        method: "get",
        params: data
      });
    },
    addLifestyleTag: function addLifestyleTag() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/subject_tag/add",
        method: "post",
        data: data
      });
    },
    updateLifestyleTag: function updateLifestyleTag() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/subject_tag/update",
        method: "post",
        data: data
      });
    },
    deleteLifestyleTag: function deleteLifestyleTag() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/subject_tag/delete",
        method: "post",
        data: data
      });
    },
    sortLifestyleTag: function sortLifestyleTag() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/subject_tag/sort",
        method: "post",
        data: data
      });
    }
  };
});